import React, { Component } from 'react'
import PropTypes from 'prop-types'

import _ from 'lodash'

import cx from 'classnames'

import './style.scss'

export default class LegendTable extends Component {
    static propTypes = {
        legend: PropTypes.array.isRequired,
    }

    renderThermometer = (key, legend, legendElement, setupItem, active, activeLarge) => {
        const nextStyle = _.get(setupItem, 'style', {})
        return (
            <div
                className={cx('legend-table-column', 'thermometer', {
                    first: key === 0,
                    last: key === legend.length - 1,
                    active,
                    'active-large': activeLarge,
                })}
                style={{
                    backgroundImage: `linear-gradient(to right, white, ${_.get(legendElement, 'color')})`,
                    ...nextStyle,
                }}
                key={`legent-table-thermometer-${key}-${_.uniqueId()}`}
            />
        )
    }

    renderLabel = (legendElement, setupItem, key) => (
        <div
            key={`legent-table-label-${key}-${_.uniqueId()}`}
            className={cx(
                'legend-table-column',
                legendElement.active && 'active',
                legendElement.active && setupItem.arrow && 'column-arrow',
                legendElement.activeLarge && 'active-large'
            )}
            style={setupItem.style}
        >
            {legendElement.active && setupItem.arrow && <div className={'arrow'}>{setupItem.value}</div>}

            {!_.isNil(setupItem.value) && !setupItem.arrow && setupItem.value}
            {!_.isNil(setupItem.value) && setupItem.visibleDefault && setupItem.value}
        </div>
    )

    renderIcon = (setupItem, key) => (
        <div
            key={`legent-table-icon-${key}-${_.uniqueId()}`}
            className={cx('legend-table-column', 'icon', setupItem.type && setupItem.type)}
            style={setupItem.style}
        />
    )

    renderHeader = (legendElement, key) => (
        <div className={cx('legend-table-row', 'header')} key={`leng-table-header-${key}`}>
            {_.map(legendElement.setup, (setupItem) => (
                <div
                    key={`legent-table-header-${key}-${_.uniqueId()}`}
                    className={cx('legend-table-column', 'legend-header')}
                    style={{
                        ...setupItem.style,
                        color: '#4d4d4d',
                        fontWeight: 'normal',
                        fontSize: 'auto',
                        ..._.get(setupItem, 'header.style', {}),
                    }}
                >
                    {_.get(setupItem, 'header.label', '')}
                </div>
            ))}
        </div>
    )

    render() {
        const { legend } = this.props

        return (
            <div className={'legend-table'}>
                {_.map(legend, (legendElement, key) => {
                    if (key === 0) return this.renderHeader(legendElement, key)
                    return null
                })}
                {_.map(legend, (legendElement, key) => {
                    const active = _.get(legendElement, 'active', false)
                    const activeLarge = _.get(legendElement, 'activeLarge', false)

                    return (
                        <div
                            className={cx('legend-table-row', active && 'active', activeLarge && 'active-large')}
                            key={`leng-table-elemen-${key}`}
                        >
                            {_.map(legendElement.setup, (setupItem) => {
                                switch (setupItem.identifier) {
                                    case 'thermometer':
                                        return this.renderThermometer(
                                            key,
                                            legend,
                                            legendElement,
                                            setupItem,
                                            active,
                                            activeLarge
                                        )
                                    case 'label':
                                        return this.renderLabel(legendElement, setupItem, key)
                                    case 'icon_label':
                                        return this.renderLabel(legendElement, setupItem, key)
                                    case 'icon':
                                        return this.renderIcon(setupItem, key)

                                    default:
                                        return (
                                            <div
                                                className={'legend-table-column'}
                                                key={`legent-table-default-${key}-${_.uniqueId()}`}
                                                style={_.get(setupItem, 'style', {})}
                                            />
                                        )
                                }
                            })}
                        </div>
                    )
                })}
            </div>
        )
    }
}
